import {Col, Collapse, CustomInput, Form, FormGroup, Label, Row,Input,Button } from "reactstrap";
import React, {useEffect, useMemo, useRef, useState} from "react";
import Select from "react-select";
import CardType from "../../lib/Core/Backend/Controllers/CardType";
import DataTable from "../Core/DataTable";
import CardTypesCtl from "./CardTypesCtl";
import Utils from "../../lib/Utils/Utils";
import Notify from "lib/Utils/Alert";
import ReactNotificationAlert from "react-notification-alert";
import $ from "jquery"



function BrandsCtl(props)
{
	const {token} = props;
	const cardTypeCtl = useMemo(() => new CardType(token),[token]);
	const [brands, setBrands] = useState([]);
	const [selectedOption, setSelectedOption] = useState(null);
	const [excludeCardTypes, setExcludeCardTypes] = useState(false);
	const [disableSelect, setDisableSelect] = useState(false);
	const [giftCardOption,setGiftcardOption] = useState([])
	const [selectedGiftCard, setSelectedGiftCard] = useState(null);
	const [data,setData] = useState([])

	const brandsSelect = props.selectRef;
	const alert = useRef();

	function onBrandSelect(val, operation)
	{
		switch (operation.action)
		{
			case "select-option":
				setSelectedOption(val);
				setSelectedGiftCard(null)
				// Utils.FillDropdown(props.cardTypeInput.current, [], null, null, 'loading...');
				// props.cardTypeInput.current.disabled = true;
				cardTypeCtl.allByBrand(val.value, data =>
				{
					if(data.error || data.errorMessage){
						Notify(alert, 'danger', data.errorMessage ?? data.error);
					} else {
						let cardTypes = data.filter(card => !props.cardTypeTable.current.dataTable.data().toArray().map(savedCards => parseInt(savedCards.id)).includes(card.id));
						// Utils.FillDropdown(props.cardTypeInput.current, cardTypes, null, (entry) => `${entry.productName} - (${entry.currency})  SKU: ${entry.sku ?? 'Not available'}`);
						// props.cardTypeInput.current.disabled = false;
						setData(data)
						const giftCardOptions = data.map((entry) => ({
							value: entry.id, // Unique ID of the gift card
							label: `${entry.productName} - (${entry.currency}) SKU: ${entry.sku ?? 'Not available'}`,
						}));
						setGiftcardOption(giftCardOptions)
					}
					
				});
				break;
			case "clear":
				setSelectedOption(null);
				setSelectedGiftCard(null)
				break;
			default:
		}
	}

	function switchCards(e) {
		if(e.target.checked){
			setExcludeCardTypes(false);
		} else {
			setExcludeCardTypes(true);
		}
	}

	function clearAll()
	{
		brandsSelect.current.clearValue();
	}


	useEffect(() => {
		if(props.brandOperation){
			if(props.brandOperation.status === 'edit'){
				setDisableSelect(true);
				setSelectedOption(brands.filter(option => 
					option.value === props.brandOperation.option.value)[0]
				);
				// Utils.FillDropdown(props.cardTypeInput.current, [], null, null, 'loading...');
				// props.cardTypeInput.current.disabled = true;
				cardTypeCtl.allByBrand(props.brandOperation.option.value, data =>
				{
					if(data.error || data.errorMessage){
						Notify(alert, 'danger', data.errorMessage ?? data.error);
					} else {
						let cardTypes = data.filter(card => !props.cardTypeTable.current.dataTable.data().toArray().map(savedCards => parseInt(savedCards.giftCardTypeId)).includes(card.id));
						// Utils.FillDropdown(props.cardTypeInput.current, cardTypes, null, (entry) => `${entry.productName} - (${entry.currency}) SKU: ${entry.sku ?? 'Not available'}`);
						// props.cardTypeInput.current.disabled = false;
						setData(data)
						const giftCardOptions = data.map((entry) => ({
							value: entry.id, // Unique ID of the gift card
							label: `${entry.productName} - (${entry.currency}) SKU: ${entry.sku ?? 'Not available'}`,
						}));
						setGiftcardOption(giftCardOptions)
					}
					
				});
			}
		}
		
	},[props.brandOperation, brands, props.cardTypeTable, excludeCardTypes, cardTypeCtl]);

	useEffect(() => {
		if(props.brandOperation)
			if(props.brandOperation.brand){
				setExcludeCardTypes(props.brandOperation.brand.cards ? true : false);
			}
	},[props.brandOperation]);

	useEffect(() =>
	{
		setBrands(props.brandList.map(brand => ({value: brand.brandId, label: brand.name})))
	},[props.brandList]);

	const handleSelectChange = (selectedOption) =>{
		setSelectedGiftCard(selectedOption);
		const filteredData = data.find((item) => item.id === selectedOption.value);
		const productName = filteredData?.productName
		const Id = filteredData?.id
		props.setCardId(Id)
		props.setProductName(productName)
		const payload = {
            purchaserId:props.purchaserId,
            giftCardTypeId: filteredData.id,
            purchaseFee: filteredData.purchaseFee || 0,
            purchaseDiscount: filteredData.purchaseDiscount || 0,
            minimumAmount: filteredData.minAmount,
            maximumAmount: filteredData.maxAmount,
            minimumQuantity: 0, 
            maximumQuantity: 0, 
            timeThreshold: -1,
            active: filteredData.active,
            currencyId: filteredData.currencyId,
            countryId: filteredData.countryId,
        };
        props.setPayload(payload)

	}

	return (
		<>
			<ReactNotificationAlert ref={alert} />
			<Form innerRef={props.formRef} onReset={clearAll}>
				<Row form>
					<Col md="6" style={{position: "relative"}}>
							<FormGroup >
								<Label for="brandId">Brand</Label>
								<Select
									value = {
										brands.filter(option => 
											 option === selectedOption)
								 }
									isDisabled={disableSelect}
									ref={brandsSelect}
									onChange={onBrandSelect}
									name="brandId"
									id="brandId"
									options={brands}
									isClearable={true}/>
							</FormGroup>
					</Col>
					<Col md={6}>
						<FormGroup className="mt-4 ml-5 pt-2">
							<CustomInput id="banBrand" name="banBrand" type="switch" label="Ban entire brand" onChange={switchCards}/>
						</FormGroup>
					</Col>
				</Row>
				<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo py-3 d-flex align-items-center" style={{cursor: "pointer"}}>
					<i className={"fas fa-chevron-down"}/>&nbsp;&nbsp;Select card Types to ban for this purchaser
				</h6>
				<Collapse isOpen={excludeCardTypes}>
					<Row form>
						<Col md={12}>
						<div className="table-responsive">
							<DataTable ref={props.cardTypeTable}
								data={null}
								columns={[{title: "Gift Card Type", data: "productName", render: $.fn.dataTable.render.text() }]}
								options={{dom: "tr"}}
								addRemoveButton={{ callback: props.removeCardType}}
							/>
							</div>
							{/* <CardTypesCtl formRef={props.cardTypeForm} onAdd={props.addCardType} cardTypeInputRef={props.cardTypeInput}/> */}
							<div ref={props.cardTypeForm} style={{display: "none"}}>
							<Row form>
								<Col md="12">
									<FormGroup>
										<Label for="cardTypeId">Gift card type</Label>
										<Select
											id="cardTypeId"
											options={giftCardOption}
											value={selectedGiftCard}
											onChange={handleSelectChange}
											placeholder="Select a gift card type"
										/>
									</FormGroup>
								</Col>
							</Row>
							
						</div>
						<Row form>
							<Col md="12" className="justify-content-end text-right">
								<Button type="button" className="btn btn-primaryTwo" onClick={props.addCardType}>Add card type</Button>
							</Col>
						</Row>
						</Col>
					</Row>
				</Collapse>
			</Form>
		</>
	);
}

export default BrandsCtl;